import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'

// Connects to data-controller="swiper"
//
// Slide effects (cube, flip, cards, coverflow, fade, creative) were dropped —
// no production slide ever used them. Only the default 'slide' translate is supported.
export default class extends Controller {
  static values = {
    direction: String,
    autoplay: Number,
    speed: Number,
  }

  connect() {
    const swiper = new Swiper(this.element, {
      loop: false,
      speed: this.speedValue || 3000,
      touchReleaseOnEdges: true,
      passiveListeners: true,
      modules: [Pagination, Navigation, Autoplay],
      autoHeight: false,
      slidesPerView: "auto",
      lazy: true,

      navigation: false,
      direction: this.directionValue || 'horizontal',

      autoplay: {
        delay: this.autoplayValue || 3000,
        disableOnInteraction: true,
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },

      grabCursor: true,
      centeredSlides: true,
    });

    if (swiper.slides.length <= 1) {
      swiper.allowTouchMove = false;
    }
  }
}
